import React from 'react';
import './UKUniversities.css';

const universities = {
  B: [
    "Bern University of Applied Sciences",
    "Bern University of the Arts",
    "University of Basel",
    "University of Bern"
  ],
  E: [
    "ETH Zurich (Swiss Federal Institute of Technology Zurich)",
    "École Polytechnique Fédérale de Lausanne (EPFL)",
  ],
  F: [
    "Franklin University Switzerland",
  ],
  G: [
    "Geneva School of Business Administration",
    "University of Geneva",
  ],
  L: [
    "Lucerne University of Applied Sciences and Arts",
    "University of Lausanne",
    "University of Lucerne",
  ],
  S: [
    "Swiss Federal Institute of Technology Lausanne (EPFL)",
    "Swiss Distance University of Applied Sciences",
    "Swiss School of Business and Technology",
    "University of St. Gallen",
  ],
  T: [
    "University of Teacher Education Zurich",
    "University of the Italian-speaking Switzerland (USI Lugano)",
  ],
  Z: [
    "Zurich University of Applied Sciences",
    "Zurich University of the Arts",
    "University of Zurich"
  ]
};

const SwitzerlandUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Switzerland Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SwitzerlandUniversities;
